(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["welcome-newsletter"]) return;
  try {
    
(() => {
  function mount(root){
    if(!root || root.dataset.mounted)return;
    root.dataset.mounted='true';
    const form=root.querySelector('form'), signup=root.querySelector('[data-zfw-signup]'), success=root.querySelector('[data-zfw-success]');
    const params=new URLSearchParams(location.search), result=root.querySelector('[data-zfw-result]').dataset.zfwResult;
    const pendingKey='zaviloo.welcome5.footerPending', subscribedKey='zaviloo.welcome5.subscribed';
    const read=key=>{try{return sessionStorage.getItem(key)}catch{return null}};
    const write=(key,value,session=false)=>{try{(session?sessionStorage:localStorage).setItem(key,String(value))}catch{}};
    const recentPending=Date.now()-Number(read(pendingKey)||0)<20*60*1000;
    const returnURL=new URL(location.href);
    returnURL.searchParams.delete('welcome_preview');returnURL.searchParams.set('customer_posted','true');returnURL.searchParams.set('zv_footer_signup','1');returnURL.hash='ZavilooFooterWelcome';
    const returnInput=form.querySelector('[name="return_to"]');if(returnInput)returnInput.value=returnURL.pathname+returnURL.search+returnURL.hash;
    form.addEventListener('submit',()=>{write(pendingKey,Date.now(),true);const button=form.querySelector('[type="submit"]');button.setAttribute('aria-busy','true');button.disabled=true;button.textContent=root.dataset.submitting});
    const showSuccess=(focus=true)=>{signup.hidden=true;success.hidden=false;write(subscribedKey,Date.now());write(pendingKey,0,true);if(focus)root.querySelector('.zfw__ready').focus({preventScroll:true})};
    if(result==='success' && (recentPending || params.get('zv_footer_signup')==='1')){
      showSuccess();
      const clean=new URL(location.href);['customer_posted','zv_footer_signup','welcome_preview'].forEach(key=>clean.searchParams.delete(key));clean.hash='ZavilooFooterWelcome';history.replaceState(null,'',clean.pathname+clean.search+clean.hash);
    }
    else{let known=null;try{known=localStorage.getItem(subscribedKey)}catch{}if(known)showSuccess(false)}
    root.querySelector('[data-zfw-copy]').addEventListener('click',async event=>{try{await navigator.clipboard.writeText(root.dataset.code);event.currentTarget.textContent=root.dataset.copied}catch{root.querySelector('[data-zfw-status]').textContent=root.dataset.copyFallback}});
    const apply=root.querySelector('[data-zfw-apply]'), destination=new URL(location.href);['customer_posted','zv_footer_signup','welcome_preview'].forEach(key=>destination.searchParams.delete(key));destination.hash='';
    apply.href=root.dataset.root+'discount/'+encodeURIComponent(root.dataset.code)+'?redirect='+encodeURIComponent(destination.pathname+destination.search);
  }
  document.querySelectorAll('[data-zfw]').forEach(mount);
  document.addEventListener('shopify:section:load',event=>mount(event.target.querySelector('[data-zfw]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zaviloo-welcome"]) return;
  try {
    
(() => {
  function mount(root) {
    if (!root || root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const dialog=root.querySelector('dialog'), form=root.querySelector('form'), teaser=root.querySelector('[data-zvw-open]');
    if (!dialog || !form || typeof dialog.showModal !== 'function') return;
    const signup=root.querySelector('[data-zvw-signup]'), success=root.querySelector('[data-zvw-success]'), status=root.querySelector('[data-zvw-status]');
    const keys={subscribed:'zaviloo.welcome5.subscribed',dismissed:'zaviloo.welcome5.dismissed',pending:'zaviloo.welcome5.pending',visits:'zaviloo.welcome5.visits'};
    const get=(key,session=false)=>{try{return (session?sessionStorage:localStorage).getItem(key)}catch{return null}};
    const set=(key,value,session=false)=>{try{(session?sessionStorage:localStorage).setItem(key,String(value))}catch{}};
    const params=new URLSearchParams(location.search), preview=params.get('welcome_preview')==='1';
    const pending=Number(get(keys.pending,true)||0), recentPending=Date.now()-pending<20*60*1000;
    const result=root.querySelector('[data-zvw-result]').dataset.zvwResult;
    let subscribed=!!get(keys.subscribed), lastFocus, oldOverflow='', timer, shown=false, cleaned=true;
    const showSuccess=()=>{signup.hidden=true;success.hidden=false;dialog.setAttribute('aria-labelledby','ZavilooWelcomeSuccess');dialog.removeAttribute('aria-describedby');teaser.textContent=root.dataset.savedTeaser};
    const offerPage=root.dataset.allowed==='true';
    const tab=root.querySelector('[data-zvw-tab]'), tabKey='zaviloo.welcome5.tab_off';
    const tabOff=()=>Date.now()-Number(get(tabKey)||0)<30*86400000;
    const showTeaser=()=>{if(offerPage && root.dataset.teaserEnabled==='true' && root.dataset.known!=='true' && !tabOff())tab.hidden=false};
    root.querySelector('[data-zvw-tab-x]').addEventListener('click',()=>{tab.hidden=true;set(tabKey,Date.now())});
    const show=()=>{
      if(dialog.open)return;
      shown=true;cleaned=false;clearTimeout(timer);lastFocus=document.activeElement;oldOverflow=document.body.style.overflow;
      if(subscribed)showSuccess();
      dialog.showModal();document.body.style.overflow='hidden';
      root.querySelector('[data-zvw-close]').focus({preventScroll:true});
    };
    /* 03/11 : le nettoyage (défilement rendu, onglet, mémoire) ne dépend plus
       du seul événement « close », qui ne part pas dans tous les navigateurs :
       la page restait bloquée après la fermeture. La croix, le fond et Échap
       l'appellent directement ; l'événement reste en secours. */
    const onClosed=()=>{if(cleaned)return;cleaned=true;document.body.style.overflow=oldOverflow;if(!subscribed)set(keys.dismissed,Date.now());showTeaser();if(lastFocus?.isConnected && lastFocus!==document.body)lastFocus.focus({preventScroll:true})};
    const hide=()=>{if(dialog.open)dialog.close();onClosed()};
    dialog.addEventListener('close',onClosed);
    dialog.addEventListener('cancel',event=>{event.preventDefault();hide()});
    root.querySelectorAll('[data-zvw-close]').forEach(button=>button.addEventListener('click',hide));
    dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)hide()});
    teaser.addEventListener('click',show);
    const returnURL=new URL(location.href);
    returnURL.searchParams.delete('welcome_preview');returnURL.searchParams.set('customer_posted','true');returnURL.searchParams.set('zv_signup','1');returnURL.hash='ZavilooWelcomeForm';
    form.querySelector('[name="return_to"]').value=returnURL.pathname+returnURL.search+returnURL.hash;
    form.addEventListener('submit',event=>{
      set(keys.pending,Date.now(),true);
      if(!event.defaultPrevented){const button=form.querySelector('[type=submit]');button.setAttribute('aria-busy','true');button.dataset.originalText=button.textContent;button.textContent=root.dataset.submitting}
    });
    window.addEventListener('pageshow',()=>{const button=form.querySelector('[type=submit]');if(button.dataset.originalText){button.textContent=button.dataset.originalText;button.removeAttribute('aria-busy')}});
    root.querySelector('[data-zvw-copy]').addEventListener('click',async event=>{try{await navigator.clipboard.writeText(root.dataset.code);event.target.textContent=root.dataset.copied}catch{status.textContent=root.dataset.copyFallback}});
    const apply=root.querySelector('[data-zvw-apply]');
    const continueURL=new URL(location.href);['customer_posted','zv_signup','welcome_preview'].forEach(key=>continueURL.searchParams.delete(key));continueURL.hash='';
    apply.href=root.dataset.root+'discount/'+encodeURIComponent(root.dataset.code)+'?redirect='+encodeURIComponent(continueURL.pathname+continueURL.search);
    apply.addEventListener('click',()=>{apply.textContent=root.dataset.applying;apply.setAttribute('aria-busy','true')});
    if(result==='success' && (recentPending || params.get('zv_signup')==='1')){
      subscribed=true;set(keys.subscribed,Date.now());set(keys.pending,0,true);showSuccess();show();
      const cleaned=new URL(location.href);['customer_posted','zv_signup','welcome_preview'].forEach(key=>cleaned.searchParams.delete(key));cleaned.hash='';history.replaceState(null,'',cleaned.pathname+cleaned.search);
      return;
    }
    if(result==='error' && recentPending){show();return}
    if(params.get('zv_footer_signup')==='1')return;
    if(preview){show();return}
    if(window.Shopify?.designMode){document.addEventListener('shopify:section:select',event=>{if(event.target.contains(root))show()});return}
    if(!offerPage || root.dataset.known==='true')return;
    if(subscribed){showSuccess();showTeaser();return}
    const dismissed=Number(get(keys.dismissed)||0);
    if(Date.now()-dismissed<Number(root.dataset.cooldown)*86400000){showTeaser();return}
    const wait=Math.max(5,Number(root.dataset.delay)||10)*1000; /* 03/11 : 10 s comme Klaviyo, plus de plancher à 30 s. */
    const cookieBannerOpen=()=>{
      /* 04/11/2026 : on regarde le vrai bandeau à l'écran. shouldShowBanner()
         reste vrai en Europe même après le choix du visiteur : la fenêtre
         -5 % ne s'ouvrait donc jamais au Royaume-Uni ni en Europe. */
      const zvck=document.querySelector('[data-zv-cookies]');
      if(zvck && !zvck.hidden)return true;
      return Array.from(document.querySelectorAll('#shopify-pc__banner,#shopify-pc__prefs')).some(element=>element.getClientRects().length>0 && getComputedStyle(element).visibility!=='hidden');
    };
    const busy=()=>document.hidden || cookieBannerOpen() || document.querySelector('.drawer.open,.cartd.open,.storyv.open,dialog[open]') || ['INPUT','TEXTAREA','SELECT'].includes(document.activeElement?.tagName);
    let readySince=null;
    const resetDelay=()=>{readySince=null};
    const attempt=()=>{
      if(shown)return;
      if(busy())resetDelay();
      else{
        if(readySince===null)readySince=performance.now();
        if(performance.now()-readySince>=wait){show();return}
      }
      timer=setTimeout(attempt,500);
    };
    document.addEventListener('visitorConsentCollected',resetDelay);
    document.addEventListener('visibilitychange',resetDelay);
    attempt();
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){clearTimeout(timer);document.removeEventListener('visitorConsentCollected',resetDelay);document.removeEventListener('visibilitychange',resetDelay);hide()}},{once:true});
  }
  document.querySelectorAll('[data-zv-welcome]').forEach(mount);
  document.addEventListener('shopify:section:load',event=>mount(event.target.querySelector('[data-zv-welcome]')));
})();

  } catch(e) { console.error(e); }
})();
})();
